/**
 * Company: Etton Group
 * User: Nikolay Zubkov
 * Date: 12.10.2021
 * Time: 16:30
 */
export function revertCoords(coordsArray) {
  if(!Array.isArray(coordsArray)) {
    return null
  }
  coordsArray = coordsArray.map(coords => {
    if (typeof coords[0] !== 'number' && Array.isArray(coords[0])) {
      coords = revertCoords(coords)
    } else {
      coords = [coords[1], coords[0]]
    }
    return coords
  })
  return coordsArray
}